// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3RlM_","title":"AfterFrontImage_title__2hT-T"};